import {
  apiClient,
  type CreateShipmentOrderImportFormatDto,
  type ShipmentOrderImportFormatEntity,
  type UpdateShipmentOrderImportFormatDto
} from '@/libs/api'

export const createShipmentOrderImportFormat = async (
  tenantKey: string,
  body: CreateShipmentOrderImportFormatDto
): Promise<ShipmentOrderImportFormatEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_formats.$post({ body })
  return data
}

export const updateShipmentOrderImportFormat = async (
  tenantKey: string,
  id: number,
  body: UpdateShipmentOrderImportFormatDto
): Promise<ShipmentOrderImportFormatEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_formats._id(id)
    .$put({ body })
  return data
}

export const deleteShipmentOrderImportFormat = async (
  tenantKey: string,
  id: number
): Promise<void> => {
  await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_formats._id(id)
    .$delete()
}
